const AND = (a, b) => a & b;
export default AND;
